<template>
  <div>
    <base-title
      title="Google Tag Manager"
      :subtitle="StringLanguage.integrations"
      link="integracoes"
    />

    <div class="integration-details">
      <div class="header">
        <div class="wrapper">
          <p class="title">Sobre o Google Tag Manager</p>
          <img
            src="@/assets/img/integration.svg"
            class="img-fluid mobile"
            alt="Integrações"
          />
          <p class="description">
            O Google Tag Manager é uma ferramenta de soluções para inserir
            scripts em sites, tornando a rotina de times de marketing muito mais
            simples e produtiva. Com seus recursos, é possível monitorar
            métricas e rastrear resultados do Analytics.
          </p>
        </div>
        <img
          src="@/assets/img/integration.svg"
          class="img-fluid desktop"
          alt="Integrações"
        />
      </div>

      <div class="register">
        <base-button
          text="Cadastrar"
          class="big w-100"
          @click="changeRoute('cadastro-google-tag-manager')"
        />

        <div class="help">
          <p>Tem dúvidas? Acesse&nbsp;</p>
          <a
            href="https://ajuda.easydelivery.com.br/apis-e-integracoes/como-configurar-o-google-tag-manager-gtm-no-easy-delivery"
            target="_blank"
            class="link"
            >https://ajuda.easydelivery.com.br/</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/integrations.css';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';

export default {
  components: {
    BaseTitle,
    BaseButton,
  },
  methods: {
    changeRoute(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>
